import { useSyncExternalStore } from 'react';
import { matchPath } from 'react-router-dom';
import { DOCUMENTS_SITE_ROUTE, LOGISTICS_SITE_ROUTE } from '@src/routePatterns';

/** The pages that have a tour, by route pattern. Adding a page's tour starts here. */
const TOURS: ReadonlyArray<{ pattern: string; id: string }> = [
  { pattern: LOGISTICS_SITE_ROUTE, id: 'logistics' },
  { pattern: DOCUMENTS_SITE_ROUTE, id: 'documents' },
];

export function tourIdForPath(pathname: string): string | null {
  return TOURS.find(({ pattern }) => matchPath(pattern, pathname) !== null)?.id ?? null;
}

/*
 * Replay requests. The profile menu lives in the shell and the tour lives in
 * the page; neither renders the other, so the request crosses as a tiny
 * external store: the last request's id and a nonce, read with
 * useSyncExternalStore. A page remounts its tour on a new nonce.
 */
let latest: { id: string; nonce: number } | null = null;
let counter = 0;
const listeners = new Set<() => void>();

export function requestTour(id: string): void {
  latest = { id, nonce: ++counter };
  listeners.forEach((listener) => listener());
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export function useTourRequest(id: string): number {
  return useSyncExternalStore(subscribe, () => (latest?.id === id ? latest.nonce : 0));
}
